import { resolveSubdomain, type PublicOwner } from "@a/subdomain";
import { extractSubdomain } from "@u/subdomain";
import { useQuery } from "@tanstack/react-query";

/**
 * Resolves the current host to a vanity owner. On the main domain returns
 * `isVanity: false` and never queries. On `<slug>.andarlabs.com` resolves the
 * owner via the public RPC (null if the slug is unassigned → treat as 404).
 */
export function useVanityHost(): {
  slug: string | null;
  owner: PublicOwner | null;
  isVanity: boolean;
  isLoading: boolean;
} {
  const slug =
    typeof window === "undefined"
      ? null
      : extractSubdomain(window.location.hostname);

  const { data, isLoading } = useQuery({
    queryKey: ["vanity-owner", slug],
    queryFn: () => resolveSubdomain(slug!),
    enabled: !!slug,
    staleTime: 1000 * 60 * 10,
  });

  return {
    slug,
    owner: data ?? null,
    isVanity: !!slug,
    isLoading: !!slug && isLoading,
  };
}
